import _forEach from 'lodash/forEach';
import templateCompiler from './template-compiler';

const lodash = { _forEach };

const html = `
<div class="<%= classes.option %> is-select">
  <label class="<%= classes.label %>"><%= title %></label>
  <select class="<%= classes.values %>" data-option-bind="<%= option.id %>">
    <% _forEach(values, function (value){ %>
      <option
        <%= value.controls %>
        <%= value.state %>
      >
        <%= value.title %>
      </option>
    <% }) %>
  </select>
</div>`;

export default templateCompiler(html, lodash);
